import React, { FC } from 'react';
import classnames from 'classnames';
import { Button } from '@src/components/Button';
import { COMPANY_ROUTE } from '@src/components/Preview/appRoutes';
import { FinishCompanyProfileModalProps } from './props';
import './styles.scss';

export const FinishCompanyProfileModal: FC<FinishCompanyProfileModalProps> = ({ className }) => {
  return (
    <div className={classnames('featured-finish-company-profile-modal', className)}>
      <div className="featured-finish-company-profile-modal__title">Finish setting up your profile</div>

      <div className="featured-finish-company-profile-modal__description">
        Fill in and publish your company profile to get full access to featured candidates.
      </div>

      <Button className="featured-finish-company-profile-modal__button" isLink to={COMPANY_ROUTE}>
        Edit company info
      </Button>
    </div>
  );
};
